import { Card } from '../../components/core/Card.jsx'
import { AdminLayout, Table } from '../../admin/AdminLayout.jsx'

// Who has been sent the two trial emails, and who has opted out of them.
export default function AdminEmails({ trial_emails = [], opted_out = [], first_results_sent = 0 }) {
  return (
    <AdminLayout title="Emails">
      <Card pad="md" title="Trial emails" description={`First-result emails sent to ${first_results_sent} businesses.`}>
        <Table
          columns={[[ 'account', 'Account' ], [ 'ending_sent', 'Trial ending (04)' ], [ 'ended_sent', 'Trial ended (05)' ]]}
          rows={trial_emails}
          empty="No trial email has been sent yet."
        />
      </Card>
      <Card pad="md" title="Opted out" description="These addresses get no trial emails. Account emails still arrive.">
        <Table columns={[[ 'email', 'Address' ], [ 'on', 'Opted out' ]]} rows={opted_out} empty="Nobody has opted out." />
      </Card>
    </AdminLayout>
  )
}
